// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UoQE","left":"styles_left__EsJVn"};